var _rect, _rect2, _path, _path2, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStoreBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 34,
    viewBox: "0 0 115 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 33,
    rx: 5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 113,
    height: 32,
    rx: 4.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.8C15.6 7.8 14.3 8.6 13.6 9.7C13 10.7 12.6 11.8 12.9 12.9C13.8 12.9 15 12.1 15.8 11C16.4 10 16.9 8.8 16.5 7.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 13C17.6 13 16.4 14 15.6 14C14.8 14 13.8 13 12.5 13C10.9 13 9.2 14.1 8.3 15.9C6.6 19.4 7.8 24.7 9.6 27.3C10.4 28.6 11.5 30 12.9 30C14.2 30 14.7 29.2 16.3 29.2C17.9 29.2 18.3 30 19.7 30C21.1 30 22.1 28.7 23 27.3C24 25.8 24.4 24.5 24.4 24.5C24.4 24.5 21.9 23.5 21.9 20.5C21.9 17.9 23.8 16.8 23.8 16.8C22.8 15.2 21.2 13 19.1 13Z",
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 14,
    fontFamily: "-apple-system, Helvetica Neue, Arial, sans-serif",
    fontSize: 8,
    fill: "white",
    letterSpacing: 0.2
  }, "Available on the")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 27,
    fontFamily: "-apple-system, Helvetica Neue, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 600,
    fill: "white"
  }, "App Store")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreBadge);
export default __webpack_public_path__ + "static/media/app-store-badge.8b0e2fe368c203d9287ce945121e98c6.svg";
export { ForwardRef as ReactComponent };